import { all, takeEvery } from 'redux-saga/effects';

import services from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* labelsWatchers() {
  yield all([
    takeEvery(EntryActionTypes.CARD_RELATION_CREATE, ({ payload }) => {
      return services.createCardRelation(payload.cardId, payload.card2Id, payload.type);
    }),
    takeEvery(EntryActionTypes.CARD_RELATION_CREATE_ERROR_CLEAR, () =>
      services.clearCardRelationCreateError(),
    ),

    takeEvery(EntryActionTypes.CARD_RELATION_DELETE, ({ payload: { id } }) =>
      services.deleteCardRelation(id),
    ),
  ]);
}
